import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = {
  key: 0,
  class: "location-loading"
}
const _hoisted_3 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = { class: "loading-text" }
const _hoisted_6 = {
  id: "map",
  ref: "mapRef",
  class: "map-area"
}
const _hoisted_7 = { class: "search-box" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "drawing-controls" }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["disabled", "title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["disabled", "title"]
const _hoisted_19 = ["disabled", "title"]
const _hoisted_20 = ["disabled", "title"]
const _hoisted_21 = {
  key: 1,
  class: "screenshot-notification"
}
const _hoisted_22 = { class: "alert alert-success" }
const _hoisted_23 = {
  key: 2,
  class: "screenshot-info-popup"
}
const _hoisted_24 = { class: "screenshot-info-content" }
const _hoisted_25 = { class: "screenshot-header" }
const _hoisted_26 = { class: "screenshot-image-container" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = {
  key: 3,
  class: "slope-popup"
}
const _hoisted_29 = { class: "slope-popup-content" }
const _hoisted_30 = { class: "input-group mb-3" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "direction-indicator mb-3" }
const _hoisted_33 = { class: "compass-rose" }
const _hoisted_34 = { class: "direction-value" }
const _hoisted_35 = { class: "input-group" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "text-muted" }
const _hoisted_38 = {
  key: 0,
  class: "alert alert-info mb-3"
}
const _hoisted_39 = { class: "d-flex justify-content-end" }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLocating)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("map.loading")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("map.findingLocation")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, null, 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("input", {
          type: "text",
          ref: "searchInput",
          class: "form-control search-input",
          placeholder: _ctx.$t('map.searchAddress')
        }, null, 8, _hoisted_9),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
        }, _cache[16] || (_cache[16] = [
          _createElementVNode("i", { class: "bi bi-x" }, null, -1)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDrawingMode('move'))),
        class: _normalizeClass(['control-button', { active: _ctx.currentMode === 'move' }]),
        title: _ctx.$t('map.moveMap')
      }, _cache[17] || (_cache[17] = [
        _createElementVNode("i", { class: "bi bi-arrows-move" }, null, -1)
      ]), 10, _hoisted_11),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.captureMapScreenshot && _ctx.captureMapScreenshot(...args))),
        class: "control-button",
        title: _ctx.$t('map.takeScreenshot')
      }, _cache[18] || (_cache[18] = [
        _createElementVNode("i", { class: "bi bi-camera" }, null, -1)
      ]), 8, _hoisted_12),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.findMyLocation && _ctx.findMyLocation(...args))),
        class: "control-button",
        title: _ctx.$t('map.findMyLocation')
      }, _cache[19] || (_cache[19] = [
        _createElementVNode("i", { class: "bi bi-crosshair" }, null, -1)
      ]), 8, _hoisted_13),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearMap && _ctx.clearMap(...args))),
        class: "control-button",
        title: _ctx.$t('map.clearMap')
      }, _cache[20] || (_cache[20] = [
        _createElementVNode("i", { class: "bi bi-arrow-repeat" }, null, -1)
      ]), 8, _hoisted_14),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setDrawingMode('delete'))),
        class: _normalizeClass([['control-button', { active: _ctx.currentMode === 'delete' }], "hidden-button"]),
        disabled: _ctx.areas.length === 0,
        title: _ctx.$t('map.deleteShape')
      }, _cache[21] || (_cache[21] = [
        _createElementVNode("i", { class: "bi bi-trash" }, null, -1)
      ]), 10, _hoisted_15),
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDrawingMode('roof'))),
        class: _normalizeClass([['control-button', { active: _ctx.currentMode === 'roof' }], "hidden-button"]),
        title: _ctx.$t('map.drawRoof')
      }, _cache[22] || (_cache[22] = [
        _createElementVNode("i", { class: "bi bi-house" }, null, -1)
      ]), 10, _hoisted_16),
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDrawingMode('obstacle'))),
        class: _normalizeClass([['control-button', { active: _ctx.currentMode === 'obstacle' }], "hidden-button"]),
        title: _ctx.$t('map.drawObstacle')
      }, _cache[23] || (_cache[23] = [
        _createElementVNode("i", { class: "bi bi-slash-circle" }, null, -1)
      ]), 10, _hoisted_17),
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setDrawingMode('slope'))),
        class: _normalizeClass([['control-button', { active: _ctx.currentMode === 'slope' }], "hidden-button"]),
        disabled: _ctx.areas.length === 0,
        title: _ctx.$t('map.insertSlope')
      }, _cache[24] || (_cache[24] = [
        _createElementVNode("i", { class: "bi bi-building" }, null, -1)
      ]), 10, _hoisted_18),
      _createElementVNode("button", {
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setDrawingMode('addPanel'))),
        class: _normalizeClass([['control-button', { active: _ctx.currentMode === 'addPanel' }], "hidden-button"]),
        disabled: _ctx.areas.length === 0,
        title: _ctx.$t('map.addSolarPanel')
      }, _cache[25] || (_cache[25] = [
        _createElementVNode("i", { class: "bi bi-grid" }, null, -1)
      ]), 10, _hoisted_19),
      _createElementVNode("button", {
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setDrawingMode('movePanel'))),
        class: _normalizeClass([['control-button', { active: _ctx.currentMode === 'movePanel' }], "hidden-button"]),
        disabled: _ctx.areas.length === 0 || _ctx.panels.length === 0,
        title: _ctx.$t('map.movePanel')
      }, _cache[26] || (_cache[26] = [
        _createElementVNode("i", { class: "bi bi-arrows-move" }, null, -1)
      ]), 10, _hoisted_20)
    ]),
    (_ctx.showScreenshotNotification)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[27] || (_cache[27] = _createElementVNode("i", { class: "bi bi-check-circle me-2" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("map.screenshotSuccess")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showScreenshotInfo && _ctx.screenshotInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t("map.screenshotTitle")), 1),
              _createElementVNode("button", {
                class: "btn-close",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeScreenshotInfo && _ctx.closeScreenshotInfo(...args)))
              })
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("img", {
                src: _ctx.screenshotInfo.imageUrl,
                alt: _ctx.$t('map.screenshot.title')
              }, null, 8, _hoisted_27)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSlopePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t("map.slope.title")), 1),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.slopeValue) = $event)),
                min: "0",
                max: "90",
                class: "form-control",
                placeholder: _ctx.$t('map.slope.enterSlope')
              }, null, 8, _hoisted_31), [
                [
                  _vModelText,
                  _ctx.slopeValue,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "input-group-text" }, "°", -1))
            ]),
            _createElementVNode("h6", null, _toDisplayString(_ctx.$t("map.slope.direction")), 1),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  class: "compass-arrow",
                  style: _normalizeStyle({ transform: `rotate(${_ctx.directionValue}deg)` })
                }, null, 4),
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "compass-label north" }, "N", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "compass-label east" }, "E", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "compass-label south" }, "S", -1)),
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "compass-label west" }, "W", -1))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.directionValue) = $event)),
                    min: "0",
                    max: "359",
                    class: "form-control",
                    placeholder: _ctx.$t('map.slope.enterDirection')
                  }, null, 8, _hoisted_36), [
                    [
                      _vModelText,
                      _ctx.directionValue,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("span", { class: "input-group-text" }, "°", -1))
                ]),
                _createElementVNode("small", _hoisted_37, _toDisplayString(_ctx.getDirectionName(_ctx.directionValue)), 1)
              ])
            ]),
            (_ctx.slopeStage === 'select-baseline')
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[34] || (_cache[34] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("map.slope.selectRidgeLine")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary me-2",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cancelSlope && _ctx.cancelSlope(...args)))
              }, _toDisplayString(_ctx.$t("map.slope.cancel")), 1),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: !_ctx.isValidSlope || !_ctx.isValidDirection,
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.applySlope && _ctx.applySlope(...args)))
              }, _toDisplayString(_ctx.slopeStage === "input"
                ? _ctx.$t("map.slope.selectRidge")
                : _ctx.$t("map.slope.apply")), 9, _hoisted_40)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}